import React from 'react'
import {Box, Link, Typography} from '@mui/material'

const Layout = ({ children }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '94vh',
            }}
        >
            {/* Content (centered) */}
            <Box
                sx={{
                    flexGrow: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                {children}
            </Box>

            {/* artificial padding - TODO */}
            <div>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
            </div>

            {/* Sticky Footer */}
            <Box
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    width: '100%',
                    backgroundColor: '#3f51b5',
                    color: '#fff',
                    padding: '20px 0',
                    textAlign: 'center',
                }}
            >
                <Typography variant="body2" align="center" style={{ width: "100%", fontSize: '12px' }}>
                    {'©'}{new Date().getFullYear()}{' '}
                    <Link color="inherit" href="https://sandymist.com" style={{ textDecoration: 'none' }}>
                        Sandymist, Inc.
                    </Link>{' '}
                </Typography>
            </Box>
        </Box>
    )
}

export default Layout
